import React from 'react';

import { Icon } from '../../icon';
import { IconProps } from '../../icon/types';

export const PreloaderIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <mask id="path-2-inside-1_162_8741" fill="white">
      <path d="M12 2C13.5781 2 15.1338 2.37349 16.5399 3.08993C17.946 3.80638 19.1626 4.84543 20.0902 6.12215C21.0178 7.39886 21.63 8.87698 21.8769 10.4357C22.1238 11.9943 21.9982 13.5893 21.5106 15.0902L19.6085 14.4721C19.9986 13.2714 20.099 11.9955 19.9015 10.7485C19.704 9.50158 19.2142 8.31909 18.4721 7.29772C17.7301 6.27635 16.7568 5.4451 15.6319 4.87195C14.507 4.29879 13.2625 4 12 4V2Z" />
    </mask>
    <path
      d="M12 2C13.5781 2 15.1338 2.37349 16.5399 3.08993C17.946 3.80638 19.1626 4.84543 20.0902 6.12215C21.0178 7.39886 21.63 8.87698 21.8769 10.4357C22.1238 11.9943 21.9982 13.5893 21.5106 15.0902L19.6085 14.4721C19.9986 13.2714 20.099 11.9955 19.9015 10.7485C19.704 9.50158 19.2142 8.31909 18.4721 7.29772C17.7301 6.27635 16.7568 5.4451 15.6319 4.87195C14.507 4.29879 13.2625 4 12 4V2Z"
      stroke="currentColor"
      strokeWidth="4"
      mask="url(#path-2-inside-1_162_8741)"
    />
  </Icon>
);
